var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('contact-query',{attrs:{"search-params":_vm.searchParams},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var results = ref.results;
var loading = ref.loading;
var query = ref.query;
var search = ref.search;
return [_c('ds-multiselect',_vm._g(_vm._b({attrs:{"value":_vm.value,"searchable":"","show-search-icon":"","value-prop":"id","label-prop":"fullName","help-text":"","help-text-prop":"email","options":_vm.normalizeOptions(results, search),"loading":loading},on:{"updateSearch":query}},'ds-multiselect',_vm.$attrs,false),_vm.$listeners))]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }